<ngx3js-renderer
    [alpha]="true"
    [controlType]="'orbit'"
    #renderer3d
    (onRender)="onAnimate()"
    (mousemove)="onMouseMove($event)"
>
    <ngx3js-camera #camera>
        <ngx3js-position [x]="-50" [y]="0" [z]="-50"></ngx3js-position>
    </ngx3js-camera>

    <ngx3js-scene #scene>
        <!-- Luces -->
        <ngx3js-light
            [type]="'AmbientLight'"
            [color]="'#ffffff'"
            [intensity]="0.8"
        ></ngx3js-light>
        <ngx3js-light [type]="'DirectionalLight'" [intensity]="0.8">
            <ngx3js-position [x]="-3" [y]="10" [z]="-10"></ngx3js-position>
        </ngx3js-light>

        <!-- Cono -->
        <ngx3js-mesh #coneMesh>
            <ngx3js-geometry
                [type]="'cone'"
                [radius]="radius"
                [height]="1"
                [radialSegments]="64"
                [openEnded]="true"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.25"
                [metalness]="0.1"
                [roughness]="0"
                [reflectivity]="1"
                [clearcoat]="1"
                [clearcoatRoughness]="0"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <!-- <ngx3js-rotation [x]="mathPiValue / 2"></ngx3js-rotation> -->
            <ngx3js-position
                [x]="0"
                [y]="length / 2 + 0.5"
                [z]="0"
            ></ngx3js-position>
        </ngx3js-mesh>

        <!-- Cilindro transparente exterior -->
        <ngx3js-mesh #containerMesh>
            <ngx3js-geometry
                [type]="'cylinder'"
                [radiusTop]="radius"
                [radiusBottom]="radius"
                [height]="length"
                [radialSegments]="64"
                [openEnded]="false"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.25"
                [metalness]="0.1"
                [roughness]="0"
                [reflectivity]="1"
                [clearcoat]="1"
                [clearcoatRoughness]="0"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <!-- <ngx3js-rotation [x]="mathPiValue / 2"></ngx3js-rotation> -->
        </ngx3js-mesh>

        <!-- Líquido -->
        <ngx3js-mesh #liquidMesh>
            <ngx3js-geometry
                [type]="'cylinder'"
                [radiusTop]="radius * 0.95"
                [radiusBottom]="radius * 0.95"
                [height]="length * percentageFull"
                [radialSegments]="64"
                [heightSegments]="32"
                [openEnded]="false"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshstandard'"
                [color]="liquidColor"
                [transparent]="true"
                [opacity]="0.6"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <ngx3js-position
                [x]="0"
                [y]="(length * (percentageFull - 1)) / 2"
                [z]="0"
            ></ngx3js-position>
        </ngx3js-mesh>

        >Ï
    </ngx3js-scene>
</ngx3js-renderer>

<!-- Tooltip -->
<div
    *ngIf="tooltipVisible"
    class="tooltip-container"
    [ngStyle]="{
        top: tooltipY + 'px',
        left: tooltipX + 'px'
    }"
>
    <!-- {{ tooltipText }} -->
    <div class="row">
        <h5 class="text-white">Bodega: Prueba 1</h5>
        <span>Capacidad MAX: 34563</span>
        <span>Estado: 50%</span>
        <span>Otro valor: 34563</span>
        <span>valores: 34563</span>
    </div>
</div>
